const LOGIN = '/login'
const ESQUECI_MINHA_SENHA = '/esqueci-minha-senha'
const ALTERAR_SENHA = '/senha/alterar'

const DASHBOARD = '/dashboard'
const PLANOS = '/planos'
const TIPOS_CONSULTAS = '/tiposconsultas'
const USUARIOS = '/usuarios'
const NOTAS_FISCAIS = '/notasfiscais'
const CONSULTAS = '/consultas'
const NOVA_CONSULTA = '/novaconsulta'
const EU = '/eu'

export {
  LOGIN,
  ALTERAR_SENHA,
  ESQUECI_MINHA_SENHA,
  DASHBOARD,
  PLANOS,
  TIPOS_CONSULTAS,
  USUARIOS,
  NOTAS_FISCAIS,
  NOVA_CONSULTA,
  CONSULTAS,
  EU,
}
